import VideoSection from 'elem/compPage/delta-3-max-series/pages/product/components/Common/VideoSection';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

const CoverSection2: React.FC = () => {
    const { t } = useLang('CoverSection2');

    return (
        <div className={`page-coverSection2 range3 ${styles.CoverSection2} GtmModuleData-section`} data-section-id="d3c-CoverSection2">
            <VideoSection
                sectionId="videoSection2"
                triggerSelector="#videoSection2"
                videoSrc="https://websiteoss.ecoflow.com/upload/video/1759042032571/02.mp4"
                posterSrc="https://websiteoss.ecoflow.com/figma-uploads/1758710520596-lyp5qx-compressed-%E7%AC%AC%E4%BA%8C%E4%B8%AA_Cutdown%201.jpg"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
            />
        </div>
    );
};

export default CoverSection2;
